import { $toast } from "vuetify-snackbar-toast";
import store from "@/store";
import authService from "../../Services/AuthService";

const permitirRoles = (rolesPermitidos) => async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await authService.syncUserWithStore();
  }
  currentUser = store.getters["Auth/user"];

  if (currentUser && !rolesPermitidos.includes(currentUser.roleName)) {
    $toast.warn("Você não tem permissão para acessar esta página");
    next({ name: "home" });
    return;
  }

  next();
};

export default permitirRoles;
